'use strict';
const NotificationBuilder = require('./NotificationBuilder');

class InformativeNotificationBuilder extends NotificationBuilder {
    constructor(id, keys) {
        super(id, keys);
        this.type = 'informative';
        this.options = this.constructor.getDefaultOptions();
    }

    static getDefaultOptions() {
        return {
            headerIconClass: 'odf-icon-loading',
            hasCloseIcon: false,
            contentType: 'status',
            hasCTA: true,
            hasRedBox: false,
        };
    }
}

module.exports = InformativeNotificationBuilder;
